/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import routes from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'vue-beauty/package/style/vue-beauty.min.css'
import vueBeauty from 'vue-beauty'
import VueRouter from 'vue-router'
import axios from 'axios'
import Vuex from 'vuex'

Vue.use(Vuex)
Vue.use(vueBeauty)
Vue.use(ElementUI)
Vue.use(VueRouter)
const router = new VueRouter({
  routes
})
Vue.config.productionTip = false

/* vuex状态管理 */
const store = new Vuex.Store({
  state: {
    serverMode: 'formal'
  },
  mutations: {
    changeFlag(state) {
      state.serverMode = state.serverMode === 'formal' ? 'test' : 'formal'
    }
  }
})
/* 加入全局遮罩处理 */
let loading // 定义loading变量

function startLoading() { // 使用Element loading-start 方法
  loading = ElementUI.Loading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.1)',
    target: document.querySelector('.ant-layout-content')
  })
}

function endLoading() { // 使用Element loading-close 方法
  loading.close()
}

let needLoadingRequestCount = 0

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
    // setTimeout(_ => {
    //   endLoading()
    // }, 300)
  }
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  created: function () {
    // http response 拦截器
    // http request 拦截器
    axios.interceptors.request.use(
      config => {
        showFullScreenLoading()
        config.headers['server-mode'] = store.state.serverMode
        return config
      },
      error => {
        return Promise.reject(error)
      }
    )
    axios.interceptors.response.use(
      response => {
        tryHideFullScreenLoading()
        if (response.data&&response.data.code !== 200) {
          // alert(response.data.error)
          this.$modal.error({
            iconType: 'frown',
            title: '',
            content: response.data.error?response.data.error:response.data.message,
            onOk: function () {
              if (response.data.code === 400) {
                router.replace({
                  path: '/',
                  query: {}
                })
                // window.location.reload()
              }
            }
          })
        }
        return response
      },
      error => {
        tryHideFullScreenLoading()
        this.$modal.error({
          iconType: 'frown',
          title: '',
          content: '服务器异常'
        })
        return Promise.reject(error.response.data)
      }
    )
  },
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js